import React, { useContext } from 'react';
import { OrgUserContextProvider, OrgUserContext } from './OrgUserContext.jsx';
import { ClientUserContextProvider, ClientUserContext } from './ClientUserContext.jsx';
import useProductDataOutsideRoutes from 'hooks/useProductDataOutsideRoutes.js';

export const UserContextProvider = ({ children }) => {
  const { clientId } = useProductDataOutsideRoutes();
  const UserProvider = clientId ? ClientUserContextProvider : OrgUserContextProvider;
  return (
    <UserProvider>
      {children}
    </UserProvider>
  );
};

export const useUser = () => {
  const { clientId } = useProductDataOutsideRoutes();
  const userContext = useContext(clientId ? ClientUserContext : OrgUserContext);
  return userContext;
};
